export enum ReportType {
    Periodic = 'Periodic',
    Baseline = 'Baseline',
}